import {
  Form,
  Row,
  Col,
  Input,
  Select,
  Button,
  InputNumber,
  DatePicker,
} from "antd"
import React, { useContext } from "react"
import styles from "../../Notice/Step/index.module.css"
import AddressForm from "../../AddressForm"
import { NoticeV2Context } from "../index"
import {
  actionNoticeOptions,
  suffixOptions,
  hmdaActionTakenOptions,
  dateSuffixIcon,
} from "../../Notice/Step/options"
import { termOptions } from "Tools/MortgageCalculators/common"
import { participantDisplayName } from "../format"

const Step1 = () => {
  const { form, setActiveKey, saveDetails, scrollTop } = useContext(NoticeV2Context)
  const participants = Form.useWatch(["L1", "participants"], form) || []

  return (
    <Row className={[styles.step, styles.step1].join(" ")} gutter={20}>
      <Col className={styles.title} span={24} offset={0}>
        Application details
      </Col>
      <Col md={8} xs={24}>
        <Form.Item label="Loan amount" name={["L1", "loanAmount"]} wrapperCol={{ offset: 0 }}>
          <InputNumber
            formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            parser={(value) =>
              value == null ? undefined : Number(String(value).replace(/\$\s?|(,*)/g, ""))
            }
            size="large"
            style={{ width: "100%" }}
            controls={false}
            max={99999999.99}
            precision={2}
          />
        </Form.Item>
      </Col>
      <Col md={8} xs={24}>
        <Form.Item label="Note rate" name={["L1", "noteRate"]}>
          <InputNumber size="large" style={{ width: "100%" }} suffix="%" controls={false} max={1000} />
        </Form.Item>
      </Col>
      <Col md={8} xs={24}>
        <Form.Item label="Term" name={["L1", "term"]}>
          <Select options={termOptions} size="large" />
        </Form.Item>
      </Col>
      <Col span={24} className={styles.divider} />
      <Form.List name={["L1", "participants"]}>
        {(fields) =>
          fields.map((field, index) => {
            const participant = participants[index] || {}
            return (
              <React.Fragment key={field.key}>
                <Col
                  className={styles.title2}
                  span={24}
                  style={{ paddingTop: index === 0 ? 12 : undefined }}
                >
                  {index === 0
                    ? "Borrower"
                    : `Co-borrower - ${participantDisplayName(participant) || index}`}
                </Col>
                <Form.Item name={[field.name, "partyId"]} hidden noStyle>
                  <Input />
                </Form.Item>
                <Form.Item name={[field.name, "isPrimary"]} hidden noStyle>
                  <Input />
                </Form.Item>
                <Col md={6} xs={24}>
                  <Form.Item label="First name" name={[field.name, "firstName"]}>
                    <Input size="large" />
                  </Form.Item>
                </Col>
                <Col md={6} xs={24}>
                  <Form.Item label="Middle name" name={[field.name, "middleName"]}>
                    <Input size="large" />
                  </Form.Item>
                </Col>
                <Col md={6} xs={24}>
                  <Form.Item label="Last name" name={[field.name, "lastName"]}>
                    <Input size="large" />
                  </Form.Item>
                </Col>
                <Col md={6} xs={24}>
                  <Form.Item label="Suffix" name={[field.name, "suffix"]}>
                    <Select options={suffixOptions} size="large" />
                  </Form.Item>
                </Col>
              </React.Fragment>
            )
          })
        }
      </Form.List>
      <AddressForm
        form={form}
        addressLabel="Present address"
        addressName={["L1", "address"]}
        countyName={["L1", "county"]}
        cityName={["L1", "city"]}
        zipName={["L1", "zipCode"]}
        unitName={["L1", "unit"]}
        stateName={["L1", "state"]}
      />
      <Col md={24} xs={24}>
        <Form.Item
          name={["L1", "accountDescription"]}
          label="Description of  Account, Transaction, or Requested Credit"
        >
          <Input.TextArea rows={4} placeholder="Add description..." />
        </Form.Item>
      </Col>
      <Col className={styles.title} span={24}>
        Action taken
      </Col>
      <Col md={18} xs={24}>
        <Form.Item name={["L1", "actionNotice"]} label="Action notice">
          <Select options={actionNoticeOptions} size="large" />
        </Form.Item>
      </Col>
      <Col md={18} xs={24}>
        <Form.Item name={["L1", "hmdaActionTaken"]} label="HMDA Action Taken">
          <Select options={hmdaActionTakenOptions} size="large" />
        </Form.Item>
      </Col>
      <Col md={6} xs={24}>
        <Form.Item name={["L1", "actionDate"]} label="Action date">
          <DatePicker size="large" format="MM/DD/YYYY" suffixIcon={dateSuffixIcon} />
        </Form.Item>
      </Col>
      <Col md={24} xs={24}>
        <Form.Item name={["L1", "noticeDetails"]} label="Notice details">
          <Input.TextArea rows={4} placeholder="Add description..." />
        </Form.Item>
      </Col>
      <Col md={18} xs={24}>
        <Form.Item
          name={["L1", "counterOfferExpires"]}
          label="Counter Offer expires / Provide missing information by "
        >
          <DatePicker
            size="large"
            format="MM/DD/YYYY"
            suffixIcon={dateSuffixIcon}
            style={{ width: 236 }}
          />
        </Form.Item>
      </Col>
      <Col md={6} xs={24}>
        <Form.Item name={["L1", "dateDenied"]} label="Date denied">
          <DatePicker size="large" format="MM/DD/YYYY" suffixIcon={dateSuffixIcon} />
        </Form.Item>
      </Col>
      <Col className={styles.optionBtn} span={24}>
        <Button
          type="primary"
          onClick={async () => {
            await saveDetails()
            setActiveKey("2")
            scrollTop()
          }}
          className={styles.next}
          size="large"
        >
          Next
        </Button>
      </Col>
    </Row>
  )
}

export default Step1
